// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__rvEcN","error":"InputSecondary_error__1kQfM","disabled":"InputSecondary_disabled__1j-Gq"};